<template>
  <section class="people-section">
    <div class="border-bottom">
      <div class="container nav-container pt-3">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item">|</li>
            <li class="breadcrumb-item active" aria-current="page">People</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="container header-container p-5">
      <div class="row pb-4">
        <div class="col-md-7">
          <h1>{{ getPillarContent.header }}</h1>
          <p class="lead" v-html="getPillarContent.main"></p>
        </div>
        <div class="col-md-5">
          <PeopleImg />
        </div>
      </div>
    </div>
    <GoalsComponent :goals="getPillarContent.social_development_goals" />
    <div class="action-row">
      <div class="container p-5">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h3>Acties en Maatregelen</h3>
            <div class="row row-cols-1 row-cols-md-1 g-2">
              <div
                class="col"
                v-for="actie in getPillarContent.actions"
                v-bind:key="actie"
              >
                <div class="card h-100">
                  <div class="card-body">
                    <p class="card-text">
                      {{ actie }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container p-5">
      <div class="row">
        <ul class="nav nav-tabs justify-content-center">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="[getActiveYear == 2022 ? 'active' : '']"
              aria-current="page"
              @click="setYear(2022)"
              >2022</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="[getActiveYear == 2023 ? 'active' : '']"
              @click="setYear(2023)"
              >2023</a
            >
          </li>
        </ul>
      </div>

      <div class="row pt-5">
        <div class="col-md-4 text-center">
          <h3 class="overlay">Leeftijdsopbouw</h3>
          <div class="ps-2 pe-2"><AgeStructure /></div>
        </div>
        <div class="col-md-4 text-center">
          <h3 class="overlay">Geslacht</h3>
          <div class="ps-2 pe-2"><GenderStructure /></div>
        </div>
        <div class="col-md-4 text-center">
          <h3 class="overlay">Ziekteverzuim</h3>
          <div class="ps-2 pe-2"><SickLeaveInfo /></div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-6 text-center">
          <InOutFlowInfo />
        </div>
        <div class="col-md-6 text-center">
          <AccidentsInfo />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PeopleImg from "@/components/PeopleImg.vue";
import AgeStructure from "@/components/AgeStructure.vue";
import GenderStructure from "@/components/GenderStructure.vue";
import SickLeaveInfo from "@/components/SickLeaveInfo.vue";
import InOutFlowInfo from "@/components/InOutFlowInfo.vue";
import AccidentsInfo from "@/components/AccidentsInfo.vue";
import GoalsComponent from "@/components/GoalsComponent.vue";

export default {
  name: "PeopleSection",
  components: {
    PeopleImg,
    AgeStructure,
    GenderStructure,
    SickLeaveInfo,
    InOutFlowInfo,
    AccidentsInfo,
    GoalsComponent,
  },
  computed: {
    getActiveYear() {
      return this.$store.getters.getActiveYear;
    },
    getPillarContent() {
      let pillars = this.$store.getters.getPillars;
      let result = pillars.filter((obj) => obj.pillar == "people");
      if (result) {
        return result[0];
      }
      return null;
    },
  },
  created() {
    this.$store.dispatch("fetchInfoValues");
    this.$store.dispatch("fetchPillars");
    this.$store.dispatch("fetchReadingguide");
    this.$store.commit("setActiveYear", 0);
    this.$store.commit("setActiveYear", 2023);
  },
  methods: {
    setYear(year) {
      this.$store.commit("setActiveYear", year);
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  --bs-breadcrumb-divider-color: #000 !important;
}
.header-container {
  padding: 2em;
}
.action-row {
  background-color: #fff3de;
}
.overlay {
  position: absolute;
  visibility: visible;
}
.active {
  font-weight: 500;
}
.nav-link {
  cursor: pointer;
}
</style>
